/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespComplementaryItemsGrid_user$ref = any;
type PdpRespSimilarItemsGrid_user$ref = any;
export type PdpRespSimilarItemsFooter_user$ref = any;
export type PdpRespSimilarItemsFooter_user = {
    readonly " $fragmentRefs": PdpRespComplementaryItemsGrid_user$ref & PdpRespSimilarItemsGrid_user$ref;
    readonly " $refType": PdpRespSimilarItemsFooter_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsFooter_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespComplementaryItemsGrid_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItemsGrid_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '150c38bc572db4f377eda689032617d6';
export default node;
